import { FC, ReactNode } from 'react';
import { Box, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Panel from '../panel';

interface Props {
  children: ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  gradientPanel: {
    position: 'relative',
    overflow: 'hidden',
    border: 'none',
    borderRadius: theme.shape.borderRadius,
    marginBottom: 16,
    zIndex: 1,
    background: theme.palette.primary.dark,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `
        radial-gradient(circle at 20% 30%, ${theme.palette.primary.main} 0%, transparent 50%),
        radial-gradient(circle at 80% 70%, ${theme.palette.secondary.main} 0%, transparent 50%),
        radial-gradient(circle at 50% 50%, ${theme.palette.primary.light} 0%, transparent 60%),
        radial-gradient(circle at 30% 90%, ${theme.palette.surface.successHighlight.main} 0%, transparent 40%)
      `,
      opacity: 0.8,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: theme.shape.borderRadius,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
      zIndex: 0,
    },
  },
}));

const GradientPanel: FC<Props> = ({ children }) => {
  const styles = useStyles();

  return (
    <Panel className={styles.gradientPanel}>
      <Box position="relative" zIndex={2} p={3}>
        {children}
      </Box>
    </Panel>
  );
};

export default GradientPanel;
